import { Box } from "@mui/material";
import Translate from "component/global/translation/translation-component";
import AnnouncementSharpIcon from '@mui/icons-material/AnnouncementSharp';

const RecordProducerNoTableFoundComponent = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", color: "#7a7a7aff" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <AnnouncementSharpIcon sx={{ fontSize: 54 }} />
            </Box>
            <Translate variant="h6" align="center" text="Failed to load current table." />
        </Box>
    );
};

export default RecordProducerNoTableFoundComponent;